<script lang="ts">
    import { onMount } from "svelte";
    import {currentText,currentLesson,currentUser,currentTyped,currentErr,currentTimes} from './store';
	import {saveStats} from './services'

    onMount(() => {
		document.onkeypress = keypress;
		document.onkeydown = keydown;
		document.onkeyup = keyup;
	});

	function keyup(e){
		e = e || window.event;
		capsLock = e.getModifierState("CapsLock");
	}

	function keydown(e) {
		e = e || window.event;
		capsLock = e.getModifierState("CapsLock");
		if (
			(e.keyCode === 8 || e.keyCode === 46) &&
			cursor > 0 &&
			cursor < arr.length
		) {
			back(e);
		}

		if (e.keyCode === 9 && cursor > 0 && cursor < arr.length){
			advance(e)
		} 
	}

	function keypress(e) {
		e = e || window.event;
		// console.log(e)
		if (e.keyCode != 8 && cursor < arr.length) {
			advance(e);
		}
	}

	function back(e){
		cursor--;
		err[cursor]=typed.pop();
		times[cursor] = currentTime;
		e.preventDefault();
	}

	function advance(e){
		cursor++;
		typed = [...typed, String.fromCharCode(e.keyCode)];
		if (cursor == 1) {
			startTime = Date.now();
		} /*if (cursor==content.length)*/ else {
			currentTime = Date.now();
			times[cursor-1] = currentTime;
		}
		e.preventDefault();
	}
    let content = ""
	$: {
		content = $currentText; 
		reset();
	}
	let typed = [];
	let err = {};
	let times = {};
	$: {
		typed = $currentTyped
		err = $currentErr
		times = $currentTimes
	}
	let cursor = 0;
	let startTime = 0;
	let currentTime = 0;
	let tabSize = 4;
	let capsLock = false;
	$: arr = content.replaceAll("\n","\r").replaceAll(" ".repeat(tabSize),"\t").split("");
	$: scrollTop = arr.slice(0,cursor).filter((x)=>x==="\r").length;
	$: {
		try{
			document.getElementsByClassName("typearea")[0].scrollTop = 25 * scrollTop;
		}
		catch{

		}
	}
	$: typingComplete = content.length === cursor;
	$: wpm = Math.round(
		((cursor / 5) * 60) / ((currentTime - startTime) / 1000)
	);
	$: accuracy = Math.round(((arr.length-arr.map((a,i)=>{return a==typed[i]?0:1}).reduce((a,b)=>a+b,0))/arr.length)*100);
	$: realAccuracy = Math.round(((arr.length-arr.map((a,i)=>{return a==typed[i]?0:1}).reduce((a,b)=>a+b,0)-Object.keys(err).length)/arr.length)*100);

	$:{
		if(typingComplete){
			//upload statistics
			console.log("Uplaoding stats");
			saveStats($currentUser.id,$currentLesson,wpm,Math.round((currentTime - startTime) / 10) / 100,accuracy,realAccuracy,{"times":times,"err":err,"typed":typed})
		}
	}
	let timers = [];
	
	function play(){
		cursor=0;
		for(let i=1;i<=Object.keys(times).length;i++){
			timers.push(setTimeout(()=>{
				cursor++;
				typed.push(typed[i-1]);
				typed=typed;//svelte reactive
			},times[""+i]-times[""+1]));
		}
		(document.activeElement as HTMLElement).blur();
	}

	function stop(){
		timers.forEach(obj=>{
			clearTimeout(obj);
		});
		timers=[];
		typed=[];
		cursor=0;
		(document.activeElement as HTMLElement).blur();
	}

	function reset() {
		typed = [];
		err = {};
		times = {};
		cursor = 0;
		startTime = 0;
		currentTime = 0;
		scrollTop = 0;
		(document.activeElement as HTMLElement).blur();
	}
</script>

<div class="typing">
	{#if !typingComplete}
    Tab Size:<input type="range" min=2 max=6 bind:value={tabSize}>{tabSize}
	<button on:click={reset}>Reset</button>
	<button on:click={play}>Play</button>
	<button on:click={stop}>Stop</button>
	
	<div class="typearea">
		{#each arr as ch, i}
			<span
				class:good={i < cursor && arr[i] === typed[i]}
				class:warning={i < cursor && arr[i] === typed[i] && Object.keys(err).includes(i+"") && err[i]!==arr[i]}
				class:bad={i < cursor && arr[i] !== typed[i]}
				class:newline={ch==="\r"}
				class:tab={ch==="\t"}
				class:cursor={cursor==i}
				>{ch}</span>
		{/each}
	</div>
	CapsLock: {capsLock}
	{/if}

	{#if !isNaN(wpm)}
		<div class="stats">
			WPM: <strong>{isNaN(wpm) ? "" : wpm}</strong>
			Total Time: <strong>{Math.round((currentTime - startTime) / 10) / 100}</strong> seconds 
			Accuracy: <strong>{accuracy}</strong> %
			Real Accuracy: <strong>{realAccuracy}</strong> %
		</div>
	{/if}
</div>

<style>
    .tab{
		display: inline-block;
		width: 2em;
		height: 1em;
		background-image: url(/img/tab.svg);
		background-repeat: no-repeat;
		background-position: center; 
		opacity: 0.3;
	}
	.newline{
		width: 1em;
		height: 1em;
		background-image: url(/img/return.svg);
		background-repeat: no-repeat;
		background-position: center; 
		opacity: 0.3;
	}
	.newline::after{
		content: "  \A";
		white-space: pre;
	}

	.cursor{
		background-color:mediumturquoise;
		opacity: 0.6;
		animation: blink-animation 1s steps(5, start) infinite;
  		-webkit-animation: blink-animation 1s steps(5, start) infinite;
	}

	@keyframes blink-animation {
		to {
			background-color: white;
		}
	}
	@-webkit-keyframes blink-animation {
		to {
			background-color: white;
		}
	}

	.typearea {
		margin:auto;
		width: 80%;
		height: 400px;
		border: 1px solid #ccc;
		padding: 5px;
		color: black;
		font-size: 2em;
		font-weight: 100;
		font-family: monospace;
		text-align: left;
		overflow-y: scroll;
	}

	.good {
		background-color: lightgreen;
	}

	.bad {
		background-color: red;
	}

	.warning{
		background-color: yellow;
	}

</style>